import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "33",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.617 5.578c-1.953 1.952-1.953 5.095-1.953 11.38s0 9.428 1.953 11.381c1.952 1.953 5.095 1.953 11.38 1.953s9.429 0 11.381-1.953c1.953-1.953 1.953-5.095 1.953-11.38s0-9.429-1.953-11.381c-1.953-1.953-5.095-1.953-11.38-1.953s-9.429 0-11.381 1.953",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9 10.29a1 1 0 1 0-2 0v13.332a1 1 0 1 0 2 0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.626 10.915a1 1 0 0 1 1.414 0l1.87 1.87a4.98 4.98 0 0 1 2.757-.83c1.019 0 1.967.306 2.757.83l1.869-1.87a1 1 0 0 1 1.414 1.415l-1.869 1.868c.524.79.829 1.739.829 2.758s-.305 1.967-.829 2.757l1.87 1.869a1 1 0 0 1-1.415 1.414l-1.869-1.869a4.98 4.98 0 0 1-2.757.829 4.98 4.98 0 0 1-2.758-.829l-1.869 1.87a1 1 0 0 1-1.414-1.415l1.87-1.869a4.98 4.98 0 0 1-.83-2.757c0-1.02.306-1.967.83-2.758l-1.87-1.869a1 1 0 0 1 0-1.414m3.04 6.04a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }